import PurchaseRequestApi from './PurchaseRequestApi';

export default PurchaseRequestApi;
